import { TopCategoriesSection } from './TopCategoriesSection';
import { AllCategoriesSection } from './AllCategoriesSection';
import { InfoSection } from './InfoSection';
import { WhyChooseUsSection } from './WhyChooseUsSection';
import { TrustBadgeSection } from './TrustBadgeSection';

interface MainMenuProps {
  headerData: HeaderData & {
    settingsData?: {
      languageSettings?: Array<{
        language: string;
        title: string;
        url: string;
        active: boolean;
      }>;
    };
  };
  onCategoryClick: (category: SidebarTopCategory) => void;
  onChatWithUsClick: () => void;
  language: string;
  country: string;
  isReturningPatient: boolean;
}

export function MainMenu({ 
  headerData, 
  onCategoryClick, 
  onChatWithUsClick,
  language,
  country,
  isReturningPatient 
}: MainMenuProps) {
  
  const topCategories = headerData.sidebarTopCategoriesV2 || [];
  const hasTopCategories = topCategories.length > 0;

  return (
    <div className="main-menu bg-white" id="main-menu">
      {hasTopCategories && (
        <>
          <TopCategoriesSection
            categories={topCategories}
            onCategoryClick={onCategoryClick}
            language={language}
            country={country}
          />

          <AllCategoriesSection
            exploreItems={headerData.exploreItems || []}
            sidebarTopCategoriesV2={topCategories}
            categoriesByRoot={headerData.categoriesByRoot || []}
            onCategoryClick={onCategoryClick}
            language={language}
            country={country}
            shouldShowOTC={headerData.shouldShowOTC}
          />
        </>
      )}

      <InfoSection
        menuLinks={headerData.menuLinks}
        onChatWithUsClick={onChatWithUsClick}
        language={language}
        country={country}
      />
      
      {!isReturningPatient && (
        <WhyChooseUsSection
          language={language}
          country={country}
        />
      )}
      
      <TrustBadgeSection
        language={language}
        country={country}
        trustedShopsData={headerData.trustedShopsData || undefined}
      />
    </div>
  );
}
